module.exports = __webpack_public_path__ + "static/media/policy-step-icon-white.c954169b.svg";